module.exports = __webpack_public_path__ + "frida.jpg?711b14e4a9cd4717e39fcd702cd735f2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frida.jpg
// module id = 293
// module chunks = 0